//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types



export const OBTENER_APERTURAS_CIERRES_POR_BOLETA = "obtenerAperturasCierresBoleta";
export const OBTENER_APERTURA_CIERRE = "obtenerAperturaCierreBoleta";

export const ACTUALIZAR_APERTURAS_CIERRES_POR_BOLETA = "registrarAperturaCierreBoleta";

export const ACTUALIZAR_TODOS_APERTURAS_CIERRES_POR_BOLETA = "actualizarTodosAperturasCierresBoleta";

export const ACTUALIZAR_APERTURA_CIERRE_POR_BOLETA = "actualizarAperturaCierreBoleta";

// mutation types
export const SET_APERTURAS_CIERRES = "setAperturasCierres";
export const SET_APERTURA_CIERRE = "setAperturaCierre";


const state = {
    aperturasCierresBoleta:[],
    aperturaCierreBoleta:[],  
    
}

const getters = {
    obtenerApertuasCierresBoleta(state) {
      return state.aperturasCierresBoleta;
    },
}

const actions = {

   
    
    /**
     * Obtener los registros de Apertura y Cierre de boletas
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_APERTURAS_CIERRES_POR_BOLETA](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/BoletaMuni/`)
                .then(({ data }) => {
                    context.commit(SET_APERTURAS_CIERRES,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Obtener las boletas asignadas a las municipalidades
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    
     async [OBTENER_APERTURA_CIERRE](context, estadoId) {
        console.log(estadoId)
        let endpoint = `api/BoletaMuni`;
        if(estadoId>0){
            endpoint = `api/BoletaMuni/Estado/${estadoId}`
        }
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_APERTURAS_CIERRES, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },
    

    /**
     * Actualizar el estado de las boletas
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [ACTUALIZAR_APERTURAS_CIERRES_POR_BOLETA](context, datos){

        let endpoint=`api/AperturaCierreBoletas/partial/actualizar`;
        
        //?Si el tipo es 2, es de forma parcial
        if(datos.tipo===2){
            endpoint=`api/AperturaCierreBoletas/partial/actualizar`;
        }


        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_APERTURA_CIERRE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        }); 
         
    },


     /**
     * Actualizar el estado de las boletas para todos los municipios de GT
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
      async [ACTUALIZAR_TODOS_APERTURAS_CIERRES_POR_BOLETA](context, datos){

        let endpoint=`api/AperturaCierreBoletas/all/actualizar`;
        
        //?Si el tipo es 2, es de forma parcial
        if(datos.tipo===2){
            endpoint=`api/AperturaCierreBoletas/partial/actualizar`;
        }


        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_APERTURA_CIERRE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        }); 
         
    },

    

    async [ACTUALIZAR_APERTURA_CIERRE_POR_BOLETA](context, datos){
        //console.log("Aqui tambien")
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/BoletaMuni/`, datos)
                .then(({ data }) => {
                    context.commit(SET_APERTURA_CIERRE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },



  


    
}

const mutations = {
    [SET_APERTURAS_CIERRES](state, data) {
        state.boletas = data;
    },

    [SET_APERTURA_CIERRE](state, data) {
        state.boleta = data;
    },

   

}


export default {
    state,
    getters,
    actions,
    mutations
}